const styles = (theme) => ({
  info: {
    flex: 1,
  },
  box: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  autocomplete: {
    flex: '1 1 60%',
    marginTop: theme.spacing(0.75),
    marginRight: theme.spacing(0.5),
  },
  button: {
    flex: '0 1 auto',
    marginTop: theme.spacing(0.75),
  },
  date: {
    marginTop: theme.spacing(1),
  },
});

export default styles;
